<div class="image-zoom-container"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()"
     (mousemove)="onMouseMove($event)"
     (contextmenu)="onContextMenu($event)">

  <!-- Imagen original -->
  <img #originalImage
       [src]="imageUrl"
       [alt]="imageAlt"
       class="original-image"
       (load)="setupImageLoad()" />

  <!-- Magnifier (lupa) -->
  <div #magnifier
       class="magnifier"
       [class.active]="isActive"
       [style.width.px]="magnifierSize"
       [style.height.px]="magnifierSize">

    <!-- Imagen ampliada dentro del magnifier -->
    <img #magnifiedImage
         [src]="magnifierImageUrl"
         [alt]="imageAlt"
         class="magnified-image" />
  </div>
</div>